import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
//icons
import { BsSearch, BsCardImage } from 'react-icons/bs';
import { GiBroom } from 'react-icons/gi';
//api
import { getAllClientMessages } from 'api/libelista';
//helpers
import { formatDateToSpanish } from 'helpers';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import ButtonCustom from 'components/backoffice/buttonCustom';

const colsMessages = [
  'Nombre',
  'Correo',
  'Departamento',
  'Mensaje',
  'Respondido',
  'Fecha de creación',
  ''
];

const ClientMessages = () => {
  const navigate = useNavigate();
  const [listMessages, setListMessages] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const query = {
    answered: '',
    full_name: '',
    email: '',
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListClientMessages = async () => {
    setIsLoading(true);
    const { data, status } = await getAllClientMessages(queryString);
    if (status === 200) {
      setListMessages(data?.results);
      setNoResults(data?.results.length === 0);
    } else {
      setListMessages([]);
      setNoResults(true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getListClientMessages();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/client_messages');
  };

  return (
    <div className="h-100 ">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Mensajes de clientes</h1>
      </div>

      <div className="d-flex my-5">
        <CustomInput
          //handleSubmit={(e) => handleSubmit(e)}
          placeholder="Buscar por nombre "
          icon={<BsSearch color="#161A25" className="icon-search" />}
          type={'search'}
        />
        <ButtonCustom onClick={handleClear} color="terciary">
          <GiBroom />
        </ButtonCustom>
      </div>
      <CustomTable cols={colsMessages} noResults={noResults} isLoading={isLoading} className="custom-table">
        {listMessages &&
          listMessages.map((listMessage, index) => {
            return (
              <tr key={listMessage.id}>
                <td>{listMessage?.full_name}</td>
                <td>{listMessage.email}</td>
                <td>{listMessage?.department}</td>
                <td> {listMessage.message}</td>
                <td>{listMessage.answered === false ? 'No' : 'Si'}</td>
                <td> {formatDateToSpanish(listMessage.created_at)}</td>
                <td className=" item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default ClientMessages;
